<template>
  <Popover
    v-if="collapsed"
    ref="popover"
    class="MentionsLine -leading leading-group"
    trigger="hover"
    :overlay-centers="true"
    overlay-centers-selector=".leading-stack"
    popover-class="popover-default leading-overlay"
    :trigger-attrs="triggerAttrs"
  >
    <template #trigger>
      <LeadingStack
        :users="faceUsers"
        :count="mentions.length"
        :reply="replyTo"
      />
    </template>
    <template #content>
      <span class="leading-row">
        <LeadingStack
          :users="faceUsers"
          :count="mentions.length"
          :reply="replyTo"
          :preview="true"
        />
        <!-- already in a popover: the replied-to one gets the sign only -->
        <MentionLink
          v-for="(mention, i) in mentions"
          :key="mention.index"
          class="mention-link leading-named"
          :content="mention.content"
          :url="mention.url"
          :reply-to="i === 0 && replyTo ? { ...replyTo, plain: true } : null"
        />
      </span>
    </template>
  </Popover>
  <span
    v-else
    class="MentionsLine"
    :class="{ '-leading': leading }"
  >
    <MentionLink
      v-for="(mention, i) in mentionsComputed"
      :key="mention.index"
      class="mention-link"
      :content="mention.content"
      :url="mention.url"
      :reply-to="i === 0 ? replyTo : null"
    /><span
      v-if="manyMentions"
      class="extraMentions"
    >
      <span
        v-if="expanded"
        class="fullExtraMentions"
      >{{ ' ' }}<MentionLink
        v-for="mention in extraMentions"
        :key="mention.index"
        class="mention-link"
        :content="mention.content"
        :url="mention.url"
      />
      </span><button
        v-if="!expanded"
        class="button-unstyled -link showMoreLess"
        @click="toggleShowMore"
      >
        {{ $t('status.plus_more', { number: extraMentions.length }) }}
      </button><button
        v-if="expanded"
        class="button-unstyled -link showMoreLess"
        @click="toggleShowMore"
      >
        {{ $t('general.show_less') }}
      </button>
    </span>
  </span>
</template>
<script src="./mentions_line.js"></script>
<style lang="scss" src="./mentions_line.scss" />
